import { environment } from "src/environments/environment"

const format_folder = '/formats/'
const base_url = environment.apiUrl;

export class formatUrl {

    public static program_pallet_format = base_url +  format_folder + 'upload_pallet_program_format.xlsx';
    public static massive_pre_bl_format = base_url +  format_folder + 'massive_pre_bl_format.xlsx';
    public static consignee_notifier_admin_format = base_url + format_folder + 'consignee_notifier_admin_format.xlsx';
    public static program_massive_create_format = base_url + format_folder + 'program_create_format.xlsx';

}
